// This file is auto-generated, do not make modifications
// tslint:disable:prettier
import React from "react";

export type Props = {
  title?: string;
  version?: any;
  css?: object | string;
} & React.SVGProps<SVGSVGElement>;

const Layer22Icon = ({ title, ...props }: Props) => (
  <svg width={17} height={17} viewBox="0 0 17 17" {...props}>
    {title && <title>{title}</title>}
    <defs>
      <filter id="layer22_a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      transform="translate(-509 -34)"
      filter="url(#layer22_a)"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g stroke="#757575" strokeWidth={1.5}>
        <path d="M517.539 35v15M524.94 42.5h-14.802" />
      </g>
    </g>
  </svg>
);
export default Layer22Icon;
